<app-preview-panel>
  <app-top-bar></app-top-bar>
  <app-sidepanel class="overflow-hidden"></app-sidepanel>
</app-preview-panel>
